import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./TermUse.css";
import Footer from "../../Home_Page_WLog/Footer/Footer";
import LoginHeader from "../../Home_Page_WLog/LoginHeader/LoginHeader";
import {
  ShieldCheck,
  FileText,
  UserCheck,
  Lock,
  Ban,
  Image,
  MessageCircle,
  Scale,
  CheckCircle2,
} from "lucide-react";

const Term_Use = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const termsData = [
    {
      number: "01",
      icon: <UserCheck size={20} />,
      title: "Eligibility",
      text: "You must be at least 18 years of age to register and use this matrimonial platform. By registering, you confirm that you are legally eligible for marriage as per the laws of your country.",
    },
    {
      number: "02",
      icon: <Lock size={20} />,
      title: "Account Responsibility",
      text: "You are responsible for maintaining the confidentiality of your login details. Any activity carried out under your account will be deemed as your responsibility.",
    },
    {
      number: "03",
      icon: <Ban size={20} />,
      title: "Prohibited Activities",
      text: "Users must not engage in fraudulent activities, share false information, demand money, or misuse the platform for purposes other than genuine matrimonial alliances.",
    },
    {
      number: "04",
      icon: <ShieldCheck size={20} />,
      title: "Privacy & Security",
      text: "Your personal information is protected; however, always exercise caution and avoid sharing sensitive data such as bank details, OTP, or Aadhaar numbers with other users.",
    },
    {
      number: "05",
      icon: <Scale size={20} />,
      title: "Termination",
      text: "We reserve the right to suspend or terminate accounts that violate these Terms of Use, engage in fraud, or misuse the platform in any manner.",
    },
    {
      number: "06",
      icon: <Image size={20} />,
      title: "Content Ownership",
      text: "All content including text, images, and profiles submitted by users remain their responsibility. Community Matrimonials is not liable for the accuracy or authenticity of user content.",
    },
    {
      number: "07",
      icon: <MessageCircle size={20} />,
      title: "Communication Policy",
      text: "Members must maintain respectful communication. Abusive, harassing, or threatening behavior towards other users will lead to suspension of your account.",
    },
  ];

  return (
    <>
      <LoginHeader />

      <div className="terms-page">
        {/* Hero Section */}
        <section className="terms-hero">
          <div className="terms-hero-overlay"></div>

          <div className="terms-float-wrap">
            {["📜", "💖", "⚖️", "🔒", "✨", "💍", "❤️", "🛡️"].map((item, index) => (
              <span key={index} className={`terms-float terms-float-${index}`}>
                {item}
              </span>
            ))}
          </div>

          <div className="terms-hero-content" data-aos="fade-up">
            <div className="terms-badge">
              <FileText size={15} />
              Legal & Platform Guidelines
            </div>

            <h1 className="terms-main-title">
              Terms of <span>Use</span>
            </h1>

            <p className="terms-subtitle">
              Please read these terms carefully before using Community Rishtey.
              These guidelines help us maintain a respectful, secure, and
              trustworthy matrimonial experience for everyone.
            </p>

            <div className="terms-top-pills">
              <span>📜 Legal Clarity</span>
              <span>🔒 Secure Usage</span>
              <span>✅ Respectful Community</span>
            </div>
          </div>
        </section>

        {/* Terms Section */}
        <section className="terms-container">
          <div className="terms-header" data-aos="fade-up">
            <span className="terms-section-badge">Community Rishtey Policy</span>
            <h2 className="terms-title">Please Follow These Terms Responsibly</h2>
            <p className="terms-description">
              These terms are designed to protect users, ensure platform integrity,
              and build a safe matrimonial environment based on trust and genuine intent.
            </p>
          </div>

          <div className="terms-grid">
            {termsData.map((item, index) => (
              <div
                key={index}
                className="terms-card"
                data-aos="zoom-in-up"
                data-aos-delay={index * 70}
              >
                <div className="terms-card-glow"></div>

                <div className="terms-card-top">
                  <div className="terms-icon-wrap">{item.icon}</div>
                  <div className="terms-number">{item.number}</div>
                </div>

                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>

          <div className="terms-final-note" data-aos="fade-up">
            <div className="terms-final-icon">
              <CheckCircle2 size={22} />
            </div>
            <div>
              <h4>Agreement & Safe Usage</h4>
              <p>
                By using Community Matrimonials, you agree to abide by these Terms
                of Use and ensure a safe, respectful, and trustworthy matrimonial experience.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Term_Use;